module.exports = __webpack_public_path__ + "img/11.2602c557.webp";